import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { BigFileAttachment } from '../../organism'
import { FlowFileMeta } from '@appbase/components/common/FlowFileUploader/flow-file-meta';

@Component({
  components: { BigFileAttachment },
})
export default class BigFileView extends Vue {
    @Prop({ type: Object }) metaData!: FlowFileMeta | null;
}
